import { GET_ALL_HELP_SUGGESTIONS, GET_HELP_SUGGESTIONS, RESET_HELP_SUGGESTIONS } from './types'

const initialState = {
  help_suggestions: [],
  help_suggestion: {},
  loading: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_HELP_SUGGESTIONS:
      return {
        ...state,
        help_suggestions: action.payload,
      }
    case GET_ALL_HELP_SUGGESTIONS:
      return {
        ...state,
        help_suggestions: action.payload,
      }
    case RESET_HELP_SUGGESTIONS:
      return {
        ...state,
        help_suggestions: action.payload,
      }
    default:
      return state
  }
}
